import { Http } from "@/http";
const prefix = `/cbo-merchant-web`;
/**
 * 账号密码登录
 */
export const userLogin = (data) => {
  return Http.post({
    url: `${prefix}/login`,
    data,
  });
};
/**
 * 发送登录验证码
 */
export const sendCode = (data) => {
  return Http.post({
    url: `${prefix}/login/sendSmsCode`,
    data,
  });
};
/**
 * 获取图片验证码
 */
export const getCodeImg = () => {
  return Http.get({
    url: `${prefix}/sliderCaptcha/getCaptcha`,
  });
};
/**
 * 验证图片验证码
 */
export const verifyCode = (data) => {
  return Http.post({
    url: `${prefix}/sliderCaptcha/verify`,
    data,
  });
};
/**
 * 发送忘记密码短信验证码
 */
export const sendPasswordVerifyCode = (data) => {
  return Http.post({
    url: `${prefix}/forgetPassword/sendSmsCode`,
    data,
  });
};
/**
 * 忘记密码短信验证码验证接口
 * @param verifyCode 短信验证码
 * @param mobile 手机号
 */
export const nextCheckCode = (data) => {
  return Http.post({
    url: `${prefix}/forgetPassword/checkVerifyCode`,
    data,
  });
};
/**
 * 重置密码
 * @param account 账号
 * @param verifyCode 短信验证码
 * @param newPasswordRepeat 重复新密码
 * @param newPassword 新密码
 */
export const setNewPassword = (data) => {
  return Http.post({
    url: `${prefix}/forgetPassword/setNewPassword`,
    data,
  });
};
/**
 * 退出登陆
 */
export const loginOut = () => {
  return Http.get({
    url: `${prefix}/loginOut`,
  });
};
/**
 * 刷新token续期 TODO暂时未知何时刷新token
 */
export const refreshToken = (data) => {
  return Http.post({
    url: `${prefix}/refreshToken`,
    data,
  });
};
